import React, { Fragment } from 'react';
import $ from 'jquery';
import ChangePageOwner from './ChangePageOwner';
import HiddenForm from '../HiddenForm';
import BookmarkItem from '../BookmarkItem';
import PinItem from './PinItem';
import DashboardPinItem from './DashboardPinItem';
import MovePageWrapper from './MovePageWrapper.jsx';
import SharePageWrapper from './SharePageWrapper';
import VerificationScheduleWrapper from './VerificationScheduleWrapper';
import {
    getCreateDraftUrlFromPageId,
    getCreateTemplateUrlFromPageId,
    getEditPageUrlFromSlug,
    getPageUrlFromSlug,
    getRevisionsUrlFromSlug,
    getSuggestEditUrlFromSlug,
} from '../../utilities/urlHelper';
import { canCreatePage, canViewRevision, canSuggestEdit } from '../../utilities/permissionsUtilities';
import { hasSuggestEditFeature, hasExternalSiteFeature } from '../../utilities/featureHelper';

class PageDropDown extends React.Component {
    clickSuggestAnUpdate = (e) => {
        e.preventDefault();
        $('.suggest-an-edit__btn').click();
    };

    getDropDownItems = () => {
        const { page, isPageSearchView, isPageShowView } = this.props;
        const categoryId = page.categoryId || page.category_id;
        const folderId = page.folderId || page.folder_id;
        const {
            id, slug, is_dashboard_pinned, dashboard_pin_id, bookmark_id, hideDashboardOptions,
        } = page;
        const showRevisionLink = isPageShowView && canViewRevision();
        const showCreateLinks = isPageShowView && canCreatePage();
        const showVerificationItem = !isPageSearchView;
        const editBtnClass = isPageShowView ? 'sm-hide' : '';
        const showSuggestEditButton = hasSuggestEditFeature() && canSuggestEdit();
        const externalSiteUrl = page.external_site_url;
        const showViewExternalSitePage = hasExternalSiteFeature() && externalSiteUrl;

        if (window.isAuthorized || page.can_update) {
            if (page.can_update) {
                return (
                    <div className="dropdown-content no-select" style={{ display: 'none' }}>
                        <a className={`dropdown-option ${editBtnClass}`} href={getEditPageUrlFromSlug(page.slug)}>Edit</a>
                        {isPageShowView && <ChangePageOwner />}
                        {!hideDashboardOptions
                            && (
                                <Fragment>
                                    <BookmarkItem pageId={id} bookmarkId={bookmark_id} />
                                    <DashboardPinItem pageId={id} dashboardPinId={dashboard_pin_id} isDashboardPinned={is_dashboard_pinned || dashboard_pin_id} />
                                    <PinItem pinToCategoryId={categoryId} pinToFolderId={folderId} isPinned={page.is_pinned} pageId={id} pinId={page.rank_id} />
                                </Fragment>
                            )}
                        {showVerificationItem && <VerificationScheduleWrapper page={page} />}
                        {isPageShowView && (
                            <span className="link dropdown-option" onClick={this.clickSuggestAnUpdate}>
                            Request an update
                            </span>
                        )}
                        <SharePageWrapper page={page} isPageShowView={isPageShowView} />
                        <MovePageWrapper page={page} />
                        {isPageShowView && <a className="dropdown-option" href={getRevisionsUrlFromSlug(slug)}>View version history</a>}
                        {showViewExternalSitePage && <a className="dropdown-option" href={externalSiteUrl}>View on External site</a>}
                        <a className="dropdown-option" href={getCreateDraftUrlFromPageId(id)}>Duplicate</a>
                        {isPageShowView && <a className="dropdown-option" href={getCreateTemplateUrlFromPageId(id)}>Create template</a>}
                        <HiddenForm color="red" method="delete" url={getPageUrlFromSlug(slug)} value="Archive" />
                        <a className="dropdown-option do-cancel">Cancel</a>
                    </div>
                );
            }
            return (
                <div className="dropdown-content no-select" style={{ display: 'none' }}>
                    {!hideDashboardOptions
                            && (
                                <Fragment>
                                    <BookmarkItem pageId={id} bookmarkId={bookmark_id} />
                                    <DashboardPinItem pageId={id} dashboardPinId={dashboard_pin_id} isDashboardPinned={is_dashboard_pinned || dashboard_pin_id} />
                                    <PinItem categoryId={categoryId} folderId={folderId} isPinned={page.is_pinned} pageId={id} pinId={page.rank_id} />
                                </Fragment>
                            )}
                    {isPageShowView && (
                        <span className="link dropdown-option" onClick={this.clickSuggestAnUpdate}>
                            Request an update
                        </span>
                    )}
                    <SharePageWrapper page={page} />
                    {showRevisionLink && <a className="dropdown-option" href={getRevisionsUrlFromSlug(slug)}>View version history</a>}
                    <a className="dropdown-option" href={getCreateDraftUrlFromPageId(id)}>Duplicate</a>
                    {isPageShowView && <a className="dropdown-option" href={getCreateTemplateUrlFromPageId(id)}>Create template</a>}
                    <a className="dropdown-option do-cancel">Cancel</a>
                </div>
            );
        }

        return (
            <div className="dropdown-content no-select" style={{ display: 'none' }}>
                {!hideDashboardOptions
                        && <BookmarkItem pageId={id} bookmarkId={bookmark_id} />}
                {isPageShowView && (
                    <span className="link dropdown-option" onClick={this.clickSuggestAnUpdate}>
                        Request an update
                    </span>
                )}
                {showSuggestEditButton && (
                    <a className="dropdown-option" href={getSuggestEditUrlFromSlug(slug)}>Suggest an edit</a>
                )}
                {!isPageShowView && <SharePageWrapper page={page} />}
                {showRevisionLink && <a className="dropdown-option" href={getRevisionsUrlFromSlug(slug)}>View version history</a>}
                {showCreateLinks && <a className="dropdown-option" href={getCreateDraftUrlFromPageId(id)}>Duplicate</a>}
                {showCreateLinks && <a className="dropdown-option" href={getCreateTemplateUrlFromPageId(id)}>Create template</a>}
                <a className="dropdown-option do-cancel">Cancel</a>
            </div>
        );
    };

    render() {
        const DropDownItems = this.getDropDownItems();

        return (
            <div className="dropdown dropdown-right-aligned flex-none right">
                {window.loggedIn
                    && (
                        <button className="page-list-dropdown dropdown-link" type="button">
                            <img className="button-icon" height="20px" src="/img/icons/dropdown-elipsis.svg" />
                        </button>
                    )}
                <div className="dropdown-overlay" style={{ display: 'none' }} />
                {DropDownItems}

            </div>
        );
    }
}

export default PageDropDown;
